import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonRow, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToolbar, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { chevronBackOutline, pawOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

const PetCreate: React.FC = () => {
    const { authKey, authenticateMember, settings, SWFullHorizLogo, showToast, SWTextDarkLogo } = useAppContext();
    
    const weightUnitsInputRef = useRef<any>();

    const router = useIonRouter();

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const authenticated = await authenticateMember();         
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                // Optionally, do something
            }
        };
        authenticate();
    }); 

    const insertPet = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/pets/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                
                if(obj.success) router.push('/account/pet/edit/' + obj.pt);
                else {
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');                    
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: Couldn\'t create this pet. ' + error + '. Try again.',
                duration: 5000,
                color: 'danger',
                position: 'middle'
            });
        }   
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/pets'>Pets</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={pawOutline}></IonIcon> New Pet<br /><span>Save details about your Pets</span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                
                <IonCard>                    
                    <IonCardContent>    
                        <form name='petForm' onSubmit={insertPet}>
                            <IonGrid>     
                                <IonRow>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonLabel color={'dark'}><b>Name</b> <em className='required'>Required</em></IonLabel>
                                        <IonInput fill='outline' name='petName' placeholder='Name' type='text'></IonInput>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='6'>
                                        <IonLabel color={'dark'}><b>Species & Breed</b> <em className='required'>Required</em></IonLabel>
                                        <IonInput fill='outline' name='petBreed' placeholder='Species & Breed' type='text'></IonInput>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Hair Length & Color</b></IonLabel>
                                    </IonCol>
                                    <IonCol sizeXs='12' sizeSm='4'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='petHair' placeholder='Length'>  
                                            <IonSelectOption value='Short'>Short</IonSelectOption>
                                            <IonSelectOption value='Medium'>Medium</IonSelectOption>
                                            <IonSelectOption value='Long'>Long</IonSelectOption>
                                        </IonSelect>
                                    </IonCol> 
                                    <IonCol sizeXs='12' sizeSm='8'>
                                        <IonInput fill='outline' name='petColor' placeholder='Color' type='text'></IonInput>
                                    </IonCol>  
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Approx. Weight</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <IonInput fill='outline' name='petWeight' placeholder='Weight' type='number'></IonInput>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <IonSelect fill='outline' labelPlacement='stacked' name='petWeightUnits' placeholder='Units' ref={weightUnitsInputRef} value={'LB'}>  
                                            <IonSelectOption value='LB'>LB</IonSelectOption>
                                            <IonSelectOption value='KG'>KG</IonSelectOption>
                                        </IonSelect>
                                    </IonCol>                                   
                                </IonRow>

                                <IonRow>
                                    <IonCol size='12'>
                                        <IonLabel color={'dark'}><b>Medical, Feeding, or Other Important Info</b></IonLabel>
                                    </IonCol>
                                    <IonCol size='12'>
                                        <IonTextarea fill='outline' name='petMedical' placeholder='Medical or Other Important Info'></IonTextarea>
                                    </IonCol>
                                </IonRow>

                            </IonGrid>  

                            <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='petFormSubmit' type='submit'>Save</IonButton>
                        </form>
                    </IonCardContent>
                </IonCard>

            </IonContent>
        </IonPage>
    );
};

export default PetCreate;
